export const normalizePath = (url: string): string => {
    try {
        const parsed = new URL(url, window.location.origin)
        const path = parsed.pathname.replace(/\/$/, '') || '/'
        const search = parsed.search ? '?' + new URLSearchParams(parsed.search).toString() : ''
        return path + search
    } catch {
        return url
    }
}
